import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

// Configuração para desenvolvimento (emulador)
const isDevelopment = import.meta.env.DEV;
const isDocker = import.meta.env.VITE_DOCKER === 'true';

const firebaseConfig = isDevelopment ? {
  apiKey: "demo-key",
  authDomain: "comunicacao-dev.firebaseapp.com", 
  projectId: "comunicacao-dev",
  storageBucket: "comunicacao-dev.appspot.com",
  messagingSenderId: "123456789",
  appId: "1:123456789:web:demo"
} : {
  apiKey: "AIzaSyASr52jhmWU6wqTfkgo5OoKGtu8_FhcGwE",
  authDomain: "suh-freitas.firebaseapp.com",
  projectId: "suh-freitas",
  storageBucket: "suh-freitas.firebasestorage.app",
  messagingSenderId: "744335888079",
  appId: "1:744335888079:web:13fc113623b4e33098b1ba",
  measurementId: "G-V00N04EKG4"
};

// Inicializa o Firebase de forma segura (só uma vez)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const firestore = getFirestore(app);

// Conecta aos emuladores apenas em desenvolvimento
if (isDevelopment && typeof window !== 'undefined') {
  const authEmulatorHost = 'localhost:9099';
  const firestoreEmulatorHost = 'localhost:8088';
  
  try {
    // Conecta ao emulador de Auth
    connectAuthEmulator(auth, `http://${authEmulatorHost}`, { disableWarnings: true });
    console.log('🔥 Firebase Auth connected to emulator:', authEmulatorHost);
  } catch (error) {
    console.log('Auth emulator connection info:', error);
  }
  
  try {
    // Conecta ao emulador de Firestore
    connectFirestoreEmulator(firestore, 'localhost', 8088);
    console.log('🔥 Firestore connected to emulator:', firestoreEmulatorHost);
  } catch (error) {
    console.log('Firestore emulator connection info:', error);
  }
}

// Inicializa o Analytics apenas em produção para evitar erros no desenvolvimento
let analytics;
if (typeof window !== 'undefined' && !isDevelopment) {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log('🔥 Firebase Analytics initialized');
    }
  });
} else if (isDevelopment) {
  console.log('🔥 Firebase Analytics disabled in development');
}

export { app, auth, firestore, analytics }; 